import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

// The session lives only in httpOnly cookies; drop any token left by older versions.
localStorage.removeItem("bf_token");

api.interceptors.request.use((cfg) => {
  const biz = localStorage.getItem("bf_business_id");
  if (biz) cfg.headers["X-Business-Id"] = biz;
  // Cada app instalada tem a sua sessão. Atenção: /admin/barbeiros é gestão, só /barbeiro é a app da equipa
  cfg.headers["X-App-Scope"] = /^(\/t\/[a-z0-9-]+)?\/barbeiro(\/|$)/.test(window.location.pathname) ? "barber" : "admin";
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    const skip = url.includes("/auth/refresh") || url.includes("/auth/login") || url.startsWith("/public");
    if (error.response?.status === 401 && cfg && !cfg._retry && !skip) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(cfg);
      } catch (e) {
        /* sessão expirada: segue o erro original */
      }
    }
    return Promise.reject(error);
  },
);

export function errMsg(e, fallback = "Algo deu errado. Tente novamente.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message && !e.response ? "Sem ligação ao servidor." : fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg.replace("Value error, ", "") : JSON.stringify(d))).join(" ");
  }
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const mediaUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.url;
}
